import React from 'react';
import { useToast } from '@components/common/toast';
import AcceptModal from './acceptModal';
import RejectModal from './rejectModal';
import InvalidDateModal from './invalidDateModal';
import AtsErrorModal from './atsErrorModal';
import EndedModal from './endedModal';
import DeletedModal from './deletedModal';

export type CompanyMessageModalType = 'ACCEPT' | 'REJECT' | 'INVALID_DATE' | 'ATS_ERROR' | 'ENDED' | 'DELETED';

interface CompanyMessageModalsProps {
  companyMessageModalState: CompanyMessageModalType | null;
  setCompanyMessageModalState: (companyMessageModalState: CompanyMessageModalType | null) => void;
  positiveOptionSn: number | null;
  negativeOptionsSn: number | null;
  date?: string | null;
  interviewLocation: string | null;
}

const CompanyMessageModals = ({
  companyMessageModalState,
  setCompanyMessageModalState,
  positiveOptionSn,
  negativeOptionsSn,
  date,
  interviewLocation,
}: CompanyMessageModalsProps) => {
  const Toast = useToast();
  const isVisible = (type: CompanyMessageModalType) => type === companyMessageModalState;
  const handleClose = () => setCompanyMessageModalState(null);

  const handleErrors = (result: string) => {
    switch (result) {
      case 'B901':
        setCompanyMessageModalState('ENDED');
        break;
      case 'B903':
        Toast({ type: 'error', iconType: 'info', content: '만료된 요청입니다.' });
        break;
      case 'B904':
        setCompanyMessageModalState('INVALID_DATE');
        break;
      case 'B908':
        setCompanyMessageModalState('ATS_ERROR');
        break;
      case 'B910':
        setCompanyMessageModalState('DELETED');
        break;
    }
  };

  return (
    <>
      {/* [D] 면접 시간 마감 모달 */}
      <InvalidDateModal visible={isVisible('INVALID_DATE')} onClose={handleClose} />

      {/* [D] 서비스 장애 모달 */}
      <AtsErrorModal visible={isVisible('ATS_ERROR')} onClose={handleClose} />

      {/* [D] 종료된 포지션 모달 */}
      <EndedModal visible={isVisible('ENDED')} onClose={handleClose} />

      {/* [D] 삭제된 포지션 모달 */}
      <DeletedModal visible={isVisible('DELETED')} onClose={handleClose} />

      {/* [D] 면접 수락 모달 */}
      <AcceptModal
        visible={isVisible('ACCEPT')}
        optionSn={positiveOptionSn}
        interviewLocation={interviewLocation}
        date={date}
        handleErrors={handleErrors}
        onClose={handleClose}
      />

      {/* [D] 면접 거부 모달 */}
      <RejectModal
        visible={isVisible('REJECT')}
        optionSn={negativeOptionsSn}
        handleErrors={handleErrors}
        onClose={handleClose}
      />
    </>
  );
};

export default CompanyMessageModals;
